<template>
  <!-- 我的需求 -->
  <div class="record">
    <van-tabs v-model="active" @click="listSelect">
      <van-tab v-for="tag in tagList" :title="tag" :key="tag.id"></van-tab>
    </van-tabs>
    <div class="h12"></div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"  v-show="list.length > 0">
      <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
      <div class="record-item-list" v-for="item in list">
        <div class="record-top" @click="enter(item)">
          <div class="record-item">
            <p class="title-1">{{item.projectName }}</p>

            <a class="pan dbj" :class="`dbj-back`+item.quoteState"  v-if="item.auditState === 2">{{item.quoteState | quoteStateFilter}}</a>
            <a class="pan dbj" :class="`bj-back`+item.auditState" v-else>{{item.auditState|stateFilter}}</a>
          </div>
          <div class="record-item">
            <div class="title-2">
                <span>业态：</span>
                <span v-for="cell in item.buildingType" :key="item.id">{{ cell.name }}</span>
                <span v-for="cell in item.secondBuildingTypeList" :key="item.id"> {{ cell.name }}</span>
            </div>
          </div>
        </div>
        <div class="record-item-bottom">
          <p>{{item.createTime}}</p>
          <a class="enter-price" v-if="item.quoteState==2" @click="enter(item)">待确认报价</a>
        </div>
        <div class="h08"></div>
      </div>
    </van-list>
    <noPaymentList v-show="list.length == 0" :noResultData="noResultData" @toListSelf="toListSelf"></noPaymentList>
    <!-- <div class="no-data">
      <img src="https://project-homedo.oss-cn-shanghai.aliyuncs.com/bd9f18a8-2069-4276-b6f2-9fe35dfba78e_nn-d.png" alt="">
      <div>暂无内容</div>
    </div> -->
  </div>
</template>

<script>
  import noPaymentList from '@/components/noPaymentList'
  import { myNeedList } from '@/api/userPerson/userPerson'
  import { getCookie } from '@/utils/cookies'
  import { quoteStateFilter,stateFilter } from '@/filters/status'
  export default {
    data() {
      return {
        active: 0,
        loading: false,
        finished: false,
        tagList: ['全部', '待审核', '审核中', '待报价', '待确认报价','确认报价','审核不通过'],
        list: [],
        hraderP: {
          title: '报价记录',
          lefticon: true
        },
        listQuery:{
          pageNum: 1,
          pageSize: 15,
          auditState:'',//审核状态:0-待审核,1-审核中,3-审核不通过,4-已取消,两个状态只能传一个，都不传-全部
          quoteState:'',//报价状态:1-待报价,2-待确认报价,3-确认报价,两个状态只能传一个，两个状态都不传-全部
          userId:''
        },
        noResultData: {
          typeName: '方案',
          callback: 'callback'
        },
      }
    },
    components: { noPaymentList },
    filters: {
      quoteStateFilter,stateFilter
    },
    mounted () {
    },
    created() {
       this.listQuery.userId = getCookie('accountId')
       console.log(this.listQuery.userId);

       this.getData()
    },
    methods: {
      listSelect (index, title) {
        this.active = index
        this.list = []
       switch (title) {
        case '待审核':
           this.listQuery.auditState = 0
           this.listQuery.quoteState = ''
           break
        case '审核中':
            this.listQuery.auditState = 1
            this.listQuery.quoteState = ''
           break
        case '审核不通过':
            this.listQuery.auditState = 3
            this.listQuery.quoteState = ''
           break
        case '待报价':
            this.listQuery.auditState = ''
            this.listQuery.quoteState = 1
           break
        case '待确认报价':
            this.listQuery.auditState = ''
            this.listQuery.quoteState = 2
           break
        case '确认报价':
            this.listQuery.auditState = ''
            this.listQuery.quoteState = 3
           break
        case '全部':
           this.listQuery.auditState = ''
           this.listQuery.quoteState = ''
           break
       }
       this.getData()
      },
      enter(item){
        console.log(item);
        this.$router.push(`/userPerson/needlistDetail.html?id=${item.id}`)
      },
      toListSelf () {
        this.getData()
      },
      getData(){
        this.listQuery.pageNum = 0
        this.listQuery.pageSize = 15
        this.finished = false
        this.onLoad()
      },
      onLoad () {
         // 调用查询接口
         let self = this
         this.listQuery.pageNum++
         myNeedList(this.listQuery).then(result => {
           if (result && result.status === 200 && result.data && result.data.code === 200 && result.data.data && result.data.data.list && result.data.data.list.length > 0) {
             self.list = self.list.concat(result.data.data.list)
             self.listQuery.pageNum = result.data.data.pageNum
             console.log(result.data.data);
             window.setTimeout(() => {
               self.loading = false
               if (result.data.data.pageNum === result.data.data.pages) {
                 self.finished = true
               }
             }, 1000)
           } else {
             self.loading = false
             self.finished = true
           }
         }).catch(() => {
           self.loading = false
           self.listQuery.total = 0
         })
      },
    }
  }
</script>

<style lang="scss">
  .record {
    .van-tab {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.45);
    }

    .van-tab--active {
      color: #2F7BFF;
      font-weight: bold;
    }

    .van-tabs__line {
      height: 2px;
      background-color: #2F7BFF !important;
    }
  }
</style>
<style lang="scss" scoped>
  .record {
    .record-item-list {
      margin-bottom: 8px;
      background: #fff;

      .record-top {
        padding: 16px 13px 0 20px;

        .record-item {
          display: flex;
          justify-content: space-between;
          padding-bottom: 12px;

          .title-1 {
            font-size: 15px;
            color: rgba(0, 0, 0, 0.65);
            font-weight: 600;
            width: 270px;
          }

          .title-2 {
            font-size: 12px;
            color: #787878;
          }
          .pan{
            display: inline-block;
            width: 74px;
            height: 18px;
            line-height: 19px;
            font-size: 12px;
            background-size: 100% 100%;
            text-align: center;
            font-size: 12px;
          }
          .bj-back0{
             color: #FF6900;
             background-image:url(../../assets/images/orange.png);
          }
          .bj-back1{
             color: #2F7BFF;
             background-image:url(../../assets/images/blue.png);
          }
          .bj-back2{
             color: #FF6900;
             background-image:url(../../assets/images/orange.png);
          }
          .bj-back3{
             color: #B5B5B5;
             background-image:url(../../assets/images/gray.png);
          }
          .bj-back4{
             color: #B5B5B5;
             background-image:url(../../assets/images/gray.png);
          }
          .dbj-back0{

          }
          .dbj-back1{
            color: #FF6900;
            background-image:url(../../assets/images/orange.png);
          }
          .dbj-back2{
            color: #FF6900;
            background-image:url(../../assets/images/orange.png);
          }
          .dbj-back3{
            color: #14AE14;
            background-image:url(../../assets/images/green.png);
          }
          .ybj{
            color: #14AE14;
          }
          .ybj-back{
             background-image:url(../../assets/images/green.png);
          }
          .ygq{
            color: #B5B5B5
          }
          .ygq-back{
             background-image:url(../../assets/images/gray.png);
          }
          span {
            color: #FF0000;
          }
        }
      }

      .record-item-bottom {
        background: #F9FBFF;
        padding: 11px 13px 11px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
          font-size: 12px;
          font-weight: 600;
          color: #2F7BFF;
          height: 27px;
          line-height: 27px;
        }

        .enter-price {
          width: 79px;
          display: inline-block;
          height: 27px;
          line-height: 27px;
          text-align: center;
          font-size: 12px;
          font-weight: 600;
          color: #FFFFFF;
          background: linear-gradient(90deg, #FFA200 0%, #FF6900 100%, #FF6900 100%);
          border-radius: 13px;
        }
      }
    }
  }

  .h12 {
    height: 12px;
    background: #EFEFF4;
  }
  .h08 {
    height: 8px;
    background: #EFEFF4;
  }
</style>



// WEBPACK FOOTER //
// src/view/userPerson/needlist.vue